import { createSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';
import { selectSystemState } from './system.selectors';
import { selectBlockState } from './block.selectors';

export const selectFlowChartComponent = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.FlowChartComponent
);
export const selectSystemPowerStateBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectFlowChartComponent,
  (systemState, flowChartComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = flowChartComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.systemPowerState;
  }
);